// Confirmation gate for the settings pages' defaults buttons -- "Set Defaults",
// "Add Default Events" and "Reset to Default". Every one of them replaces or
// appends to settings the tenant may have hand-tuned, so none should fire on a
// single stray click.
//
// These used to call a bare confirm() straight out of the template
// (@click="confirm('...') && apply_x_defaults()"). That only works in a
// production build: Vue 2 compiles templates to with(this){...}, and the dev
// build's render proxy claims any identifier that isn't in its small allowed-
// globals list, so `confirm` resolved to an undefined instance property and the
// click threw a TypeError before the handler ever ran -- the button looked dead
// on the dev server. Going through a method keeps the confirmation working in
// both builds and matches the $bvModal confirms used elsewhere in the app.
export default {
  methods: {
    // message: what the button is about to do. action: called only on confirm.
    // okTitle doubles as the dialog title so the wording matches the button.
    // Resolves true when the action ran, false when the user backed out.
    async confirmDefaults(message, action, okTitle = 'Set Defaults') {
      const ok = await this.$bvModal.msgBoxConfirm(message, {
        title: okTitle,
        okTitle,
        okVariant: 'primary',
        cancelTitle: 'Cancel',
        centered: true,
      }).catch(() => false)
      if (!ok) return false
      await action()
      return true
    },
  },
}
